module.exports = __webpack_public_path__ + "1d82f7d36c21d30d439a6bf835c39b4e.svg";